import { LinkProps, Link as LinkRouter, useNavigate } from 'react-router-dom';

import styles from './LinkRow.module.scss';


type TProps = Omit<LinkProps, 'to'> & {
	children?: React.ReactNode;
	target?: string;
	history?: number;
	className?: string;
	to?: string;
	border?: boolean;
};

export function LinkRow(props: TProps) {
	const {
		to = '#',
		children = '',
		className = '',
		history = 0,
		border = true,
		...restProps
	} = props;

	const classNames = [styles.link];
	if (className) {
		classNames.push(className);
	}

	if (border) {
		classNames.push(styles.border);
	}

	if (history) {
		const navigate = useNavigate();

		return (
			<span
				onClick={ () => navigate(history) }
				className={ classNames.join(' ') }
				{ ...restProps }
			>
				{ children }
			</span>
		);
	}

	return (
		<LinkRouter
			to={ to }
			className={ classNames.join(' ') }
			{ ...restProps }
		>
			{ children }
		</LinkRouter>
	);
}
